import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrls, apiHostUrl, unauth } from '../../shared/utils/globalConfig';
import { addHeaders } from '../../shared/utils/globalUtils';

export const reptoolApi = createApi({
    reducerPath: 'reptool',
    baseQuery: fetchBaseQuery({
        baseUrl: apiHostUrl,
        prepareHeaders: (headers) => {
            return addHeaders(headers, unauth);
        }
    }),
    endpoints: (builder) => ({
        getReptoolByName: builder.query({
            query: (payload) => ({
                url: unauth ? apiUrls?.repToolUaUrl : apiUrls?.repToolUrl,
                method: 'POST',
                body: payload
            })
        }),
    }),

})

export const { useGetReptoolByNameQuery } = reptoolApi;